import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import $ from 'jquery';
import bindModel from '../../../common/bindModel.js';
import SVGA from 'svgaplayerweb';
import MyContext from '../../../common/MyContext';

// const $ = window.$;

const MAX_AI_GENERATIONS = 5;

export default class ModalUpdateRoomEvent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            roomEvent: null,
            aiGenerating: false,
            verticalAiGenerationCount: 0,
            horizontalAiGenerationCount: 0,
            reviewAction: null,
            rejectReason: '',
            bannerDescription: '',
        }

		this.uploadAnimationToS3 = this.uploadAnimationToS3.bind(this);
		this.handleChangeIsSendNotification = this.handleChangeIsSendNotification.bind(this);
		this.handleChangeIsHidden = this.handleChangeIsHidden.bind(this);
		this.saveRoomEvent = this.saveRoomEvent.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this); // Thêm method mới
        this.generateBannersWithAI = this.generateBannersWithAI.bind(this);
        this.reviewRoomEvent = this.reviewRoomEvent.bind(this);
        this.startReject = this.startReject.bind(this);
        this.cancelReject = this.cancelReject.bind(this);
        this.onChangeRejectReason = this.onChangeRejectReason.bind(this);
    }

    componentWillReceiveProps(props) {
        console.table(this.state.roomEvent);

        $("#choiceStickerDeepAr").html("");
        $("#choiceHashtag").html("");

        // Clear state ngay lập tức trước khi set dữ liệu mới
        this.setState({
            roomEvent: null,
            aiGenerating: false,
            verticalAiGenerationCount: 0,
            horizontalAiGenerationCount: 0,
            reviewAction: null,
            rejectReason: '',
            bannerDescription: '',
        }, () => {
            // Sau khi clear xong, set dữ liệu mới
            let roomEvent = props.roomEvent;
            this.setState({
                roomEvent: roomEvent
            });
        });
    }

    componentDidMount() {
        console.log('ModalUpdateRoomEvent mounted');
        
        // Thêm event listener cho việc đóng modal
        $('#modalUpdateRoomEvent').on('hidden.bs.modal', this.handleModalClose);
    }

    componentWillUnmount() {
        // Remove event listener khi component unmount
        $('#modalUpdateRoomEvent').off('hidden.bs.modal', this.handleModalClose);
    }

    // Thêm method để handle việc đóng modal
    handleModalClose() {
        // Clear state khi modal đóng
        this.setState({
            roomEvent: null,
            aiGenerating: false,
            verticalAiGenerationCount: 0,
            horizontalAiGenerationCount: 0,
            reviewAction: null,
            rejectReason: '',
            bannerDescription: '',
        });
        
        // Clear các input fields
        $("#choiceStickerDeepAr").html("");
        $("#choiceHashtag").html("");
        
        // Gọi callback từ parent component nếu có
        if (this.props.onModalClose) {
            this.props.onModalClose();
        }
    }

    guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }

    bannerRequestData() {
        const roomEvent = this.state.roomEvent || {};
        const liveRoom = roomEvent.liveRoom || {};
        return {
            eventName: (roomEvent.name || '').trim(),
            description: (this.state.bannerDescription || '').trim(),
            timeStart: roomEvent.timeStart ? new Date(roomEvent.timeStart).getTime() : null,
            liveRoomName: (liveRoom.name || '').trim(),
            liveRoomUid: String(liveRoom.uid || '').trim(),
        };
    }

    uploadGeneratedImage(image, property) {
        return new Promise((resolve, reject) => {
            const mimeType = image.mimeType || 'image/png';
            const extension = mimeType === 'image/jpeg' ? 'jpg' : (mimeType.split('/')[1] || 'png');
            const binary = window.atob(image.data);
            const bytes = new Uint8Array(binary.length);
            for (let index = 0; index < binary.length; index++) {
                bytes[index] = binary.charCodeAt(index);
            }

            const file = new Blob([bytes], {type: mimeType});
            const bucketName = 'ikara-data/images/contests';
            const keyName = this.guid() + '.' + extension;
            const formData = new FormData();
            formData.append('file', file, keyName);
            formData.append('bucketName', bucketName);
            formData.append('objectKey', keyName);
            formData.append('contentType', mimeType);

            $.ajax({
                url: global.config.apiDomain + '/web.UploadFile',
                data: formData,
                processData: false,
                contentType: false,
                type: 'POST',
                success: () => {
                    const url = 'https://data4.ikara.co/data/minio/' + bucketName + '/' + keyName;
                    this.setState(previousState => ({
                        roomEvent: {
                            ...previousState.roomEvent,
                            [property]: url,
                        }
                    }), () => resolve(url));
                },
                error: reject,
            });
        });
    }

    async generateBannersWithAI(mode) {
        if (this.state.aiGenerating) return;
        if (mode !== 'horizontal' && this.state.verticalAiGenerationCount >= MAX_AI_GENERATIONS) return;
        if (mode !== 'vertical' && this.state.horizontalAiGenerationCount >= MAX_AI_GENERATIONS) return;

        const requestData = this.bannerRequestData();
        if (!requestData.eventName || !requestData.timeStart || !requestData.liveRoomName || !requestData.liveRoomUid) {
            return toast.error('Nhập tên sự kiện, ID phòng, tên phòng và thời gian bắt đầu trước khi tạo banner');
        }
        if (mode === 'horizontal' && !this.state.roomEvent.miniBackgroundUrl) {
            return toast.error('Cần có banner dọc trước khi tạo lại banner ngang');
        }

        this.setState(previousState => ({
            aiGenerating: true,
            verticalAiGenerationCount: mode !== 'horizontal'
                ? previousState.verticalAiGenerationCount + 1
                : previousState.verticalAiGenerationCount,
            horizontalAiGenerationCount: mode !== 'vertical'
                ? previousState.horizontalAiGenerationCount + 1
                : previousState.horizontalAiGenerationCount,
        }));

        try {
            let verticalImageUrl = this.state.roomEvent.miniBackgroundUrl;

            if (mode !== 'horizontal') {
                const verticalResponse = await axios.post(
                    global.config.apiDomain + '/mc-live-room/web/room-event-banners/vertical',
                    requestData
                );
                if (verticalResponse.data.status !== 'OK' || !verticalResponse.data.data) {
                    throw new Error(verticalResponse.data.message || 'Không tạo được banner dọc');
                }

                verticalImageUrl = await this.uploadGeneratedImage(verticalResponse.data.data, 'miniBackgroundUrl');
            }

            if (mode !== 'vertical') {
                const horizontalResponse = await axios.post(
                    global.config.apiDomain + '/mc-live-room/web/room-event-banners/horizontal',
                    {
                        ...requestData,
                        verticalImageUrl: verticalImageUrl,
                    }
                );
                if (horizontalResponse.data.status !== 'OK' || !horizontalResponse.data.data) {
                    throw new Error(horizontalResponse.data.message || 'Không tạo được banner ngang');
                }

                await this.uploadGeneratedImage(horizontalResponse.data.data, 'largeBackgroundUrl');
            }

            const successMessage = mode === 'vertical'
                ? 'Đã tạo và lưu banner dọc'
                : mode === 'horizontal'
                    ? 'Đã tạo và lưu banner ngang'
                    : 'Đã tạo và lưu banner dọc, banner ngang';
            toast.success(successMessage);
        } catch (error) {
            console.error('Generate RoomEvent banners error:', error);
            const message = error.response && error.response.data
                ? error.response.data.message
                : error.message;
            toast.error(message || 'Tạo banner AI thất bại, hãy thử lại');
        } finally {
            this.setState({aiGenerating: false});
        }
    }

    startReject() {
        this.setState({reviewAction: 'REJECT'});
    }

    cancelReject() {
        this.setState({reviewAction: null, rejectReason: ''});
    }

    onChangeRejectReason(event) {
        this.setState({rejectReason: event.target.value});
    }

    reviewRoomEvent(action) {
        const {roomEvent, rejectReason} = this.state;
        if (!roomEvent) return;

        if (action === 'APPROVE' && (!roomEvent.miniBackgroundUrl || !roomEvent.largeBackgroundUrl)) {
            toast.warning('Cần có đủ banner dọc và banner ngang trước khi duyệt');
            return;
        }
        if (action === 'REJECT' && !rejectReason.trim()) {
            toast.warning('Vui lòng nhập lý do từ chối');
            return;
        }

        const adminId = this.context && this.context.user ? this.context.user.facebookId : null;
        const requestData = {
            deviceId: adminId || 'admin-web',
            platform: 'ANDROID',
            language: 'vi',
            packageName: 'com.yokara',
            version: global.config.yokara_version,
            requestTime: Date.now(),
            data: {
                id: roomEvent.id,
                action: action,
                adminId: adminId,
                rejectReason: action === 'REJECT' ? rejectReason.trim() : null,
                miniBackgroundUrl: roomEvent.miniBackgroundUrl,
                largeBackgroundUrl: roomEvent.largeBackgroundUrl,
                mainBackgroundUrl: roomEvent.mainBackgroundUrl,
            }
        };

        this.setState({loading: true});
        axios.post(
            global.config.apiDomain + '/mc-live-room/external/room-event/review',
            JSON.stringify(requestData),
            {headers: {'Content-Type': 'application/json'}}
        ).then(res => {
            this.setState({loading: false});
            if (res.data.status === 'OK') {
                window.$('#modalUpdateRoomEvent').modal('hide');
                toast.success(action === 'APPROVE' ? 'Đã duyệt sự kiện' : 'Đã từ chối sự kiện');
                this.props.resetList();
                if (this.props.onModalClose) this.props.onModalClose();
            } else {
                toast.warning(res.data.message || 'Có lỗi xảy ra');
            }
        }, error => {
            this.setState({loading: false});
            toast.error((error.response && error.response.data && error.response.data.message)
                || 'Có lỗi xảy ra khi xử lý sự kiện');
        });
    }

    saveRoomEvent() {
        let obj = { ...this.state.roomEvent };

        console.log("Data: ", {...this.state.roomEvent});

		obj.liveRoomUID = obj.liveRoom.uid;
		delete obj.liveRoom;
        
        // Convert date strings to long timestamps
        if (obj.timeStart) {
            obj.timeStart = new Date(obj.timeStart).getTime();
        }
        if (obj.timeEnd) {
            obj.timeEnd = new Date(obj.timeEnd).getTime();
        }
        if (obj.timeShowStart) {
            obj.timeShowStart = new Date(obj.timeShowStart).getTime();
        }
        if (obj.timeSendNotification) {
            obj.timeSendNotification = new Date(obj.timeSendNotification).getTime();
        }
        
        if (
            obj == undefined ||
            !obj.liveRoomUID ||
            !obj.language ||
            !obj.miniBackgroundUrl ||
            !obj.largeBackgroundUrl ||
            !obj.name
        ) {
            console.table(obj);
            return toast.error('Nhập đầy đủ thông tin CÀI ĐẶT CHÍNH');
        }

		if(!obj.id){
            if(obj.timeStart > obj.timeEnd) {
                return toast.error('Thời gian bắt đầu phải nhỏ hơn thời gian kết thúc');
            }
            if(obj.timeShowStart > obj.timeStart) {
                return toast.error('Thời gian hiển thị phải nhỏ hơn thời gian bắt đầu');
            }
    
            if(obj.isSendNotification && !obj.title) {
                return toast.error('Tiêu đề thông báo không được để trống');
            }
    
            if(obj.isSendNotification && !obj.content) {
                return toast.error('Nội dung thông báo không được để trống');
            }
    
            if(obj.isSendNotification && obj.timeSendNotification > obj.timeStart) {
                return toast.error('Thời gian gửi thông báo phải nhỏ hơn thời gian bắt đầu');
            }
    
            if(obj.isSendNotification && obj.timeSendNotification < new Date().getTime()) {
                return toast.error('Thời gian gửi thông báo phải lớn hơn thời gian hiện tại');
            }

        }else{
            if(obj.timeStart > obj.timeEnd) {
                return toast.error('Thời gian bắt đầu phải nhỏ hơn thời gian kết thúc');
            }
            if(obj.isSendNotification && !obj.title) {
                return toast.error('Tiêu đề thông báo không được để trống');
            }
    
            if(obj.isSendNotification && !obj.content) {
                return toast.error('Nội dung thông báo không được để trống');
            }
        }

        // Wrap data in ApiRequest structure
        const requestData = {
            data: obj
        };

        const myJSON = JSON.stringify(requestData);
        console.log(myJSON);

        this.setState({
            loading: true
        });
        axios.post(global.config.apiDomain + '/mc-live-room/external/room-event/create', myJSON, {
                headers: {
                    'Content-Type': 'application/json',
                },
             })
            .then(res => {
                this.setState({
                    loading: false
                });

                if (res.data.status == "OK") {
                    window.$("#modalUpdateRoomEvent").modal("hide");
                    this.props.resetList();
                    toast.success(res.data.message || 'Tạo sự kiện thành công');
                    
                    // Clear state sau khi save thành công
                    this.setState({
                        roomEvent: null
                    });
                } else {
                    toast.warning(res.data.message || 'Có lỗi xảy ra');
                }
            }, error => {
                this.setState({
                    loading: false
                });
                console.error('Error:', error);
                toast.error((error.response && error.response.data && error.response.data.message) || 'Có lỗi xảy ra khi tạo sự kiện');
            })
    }

    uploadAnimationToS3(event) {
        let target = event.target;
        let previewUrl = URL.createObjectURL(target.files[0]);
        let extension = target.files[0].name.split('.').pop().toLowerCase();

        this.setState({
            ...this.state,
            roomEvent: {
                ...this.state.roomEvent,
                [target.name]: previewUrl
            },
            loading: true,
            // Lưu thông tin về loại file
            fileTypes: {
                ...this.state.fileTypes,
                [target.name]: extension
            }
        });
        const imageExtensions = [
            // Raster formats (bitmap)
            "jpg", "jpeg", "png", "gif", "bmp", "tif", "tiff",
          
            // Vector formats
            "svg", "ai", "eps", "pdf", "svga", "json", 
          
            // Raw and photo editing formats
            "psd", "xcf", "raw", "cr2", "nef", "arw", "orf", "dng",
          
            // Animated image formats
            "apng", "webp", "mng",
          
            // High efficiency / compressed formats
            "heic", "heif", "jp2", "jxl",
          
            // Miscellaneous / less common formats
            "ico", "dds", "tga", "pct", "pict", "wmf", "emf", "svgz"
          ];

        

        if (!imageExtensions.includes(extension)) {
            toast.error("File không hợp lệ");
            this.setState({
                ...this.state,
                roomEvent: {
                    ...this.state.roomEvent,
                    [target.name]: ''
                },
                loading: false
            });
            return;
        }

    
        if (target.files && target.files[0]) {
            const img = new Image();
            img.src = URL.createObjectURL(target.files[0]);

            this.processFileUpload(target, extension);
        }
    }

    processFileUpload(target, extension) {
        if (target.files[0] && target.files[0].size > 10495760) {
            toast.error("Kích thước file phải dưới 10mb.");
            return;
        }
        
        let property = target.name;
        let roomEvent = this.state.roomEvent;
        let bucketName = "ikara-data/images/contests";
        let keyName = this.guid() + "." + extension;
        
        // Xác định contentType đúng cho từng loại file
        let contentType;
        if (extension === 'svga') {
            contentType = 'application/json'; // SVGA là file JSON
        } else if (extension === 'json') {
            contentType = 'application/json';
        } else {
            contentType = "image/" + extension;
        }
        
        let fileReader = new FileReader();
        fileReader.onload = function () {
            let fd = new FormData();
            fd.append('file', target.files[0]);
            fd.append('bucketName', bucketName);
            fd.append('objectKey', keyName);
            fd.append('contentType', contentType); // Sử dụng contentType đã xác định
            
            $.ajax({
                url: global.config.apiDomain + '/web.UploadFile',
                data: fd,
                processData: false,
                contentType: false,
                type: 'POST',
                success: function (data) {
                    this.setState({
                        loading: false
                    });
                    this.setState({
                        roomEvent: {
                            ...roomEvent,
                            [property]: 'https://data4.ikara.co/data/minio/' + bucketName + '/' + keyName
                        }
                    });
                }.bind(this),
                error: function (error) {
                    console.error('Upload error:', error); // Thêm log để debug
                    this.setState({
                        loading: false
                    });
                    toast.error("Tạo link ảnh thất bại, hãy thử lại");
                    this.setState({
                        roomEvent: {
                            ...roomEvent,
                            [property]: ''
                        }
                    });
                }.bind(this)
            });
        }.bind(this);
        fileReader.readAsArrayBuffer(target.files[0]);
    }
    
    handleChangeIsSendNotification = (event) => {
        this.setState({
            roomEvent: {
                ...this.state.roomEvent,
                isSendNotification: event.target.checked,
                title: (event.target.checked && !this.state.roomEvent.title && this.state.roomEvent.name)
                    ? '[SỰ KIỆN] ' + this.state.roomEvent.name.trim()
                    : this.state.roomEvent.title,
                timeSendNotification: event.target.checked ? new Date().toLocaleString("sv", {timeZone: "Asia/Ho_Chi_Minh"}).replace(" ", "T") : ''
            }
        });
    }

    handleChangeIsHidden = (event) => {
        this.setState({
            roomEvent: {
                ...this.state.roomEvent,
                isHidden: event.target.checked,
            }
        });
    }

    // Thêm hàm để kiểm tra loại file từ URL
    isSVGAFile(url) {
        if (!url) return false;
        return url.toLowerCase().endsWith('.svga') || url.toLowerCase().endsWith('.json');
    }

    // Thêm hàm để render SVGA
    renderSVGA(url, label) {
        const canvasId = `svga-${label.replace(/\s+/g, '-').toLowerCase()}`;
        
        // Sử dụng setTimeout để đảm bảo DOM đã render
        setTimeout(() => {
            if (url && document.getElementById(canvasId)) {
                try {
                    const player = new SVGA.Player(`#${canvasId}`);
                    const parser = new SVGA.Parser(`#${canvasId}`);
                    
                    parser.load(url, (videoItem) => {
                        if (videoItem) {
                            player.setVideoItem(videoItem);
                            player.startAnimation();
                        }
                    }, (error) => {
                        console.error('SVGA error:', error);
                    });
                } catch (error) {
                    console.error('SVGA init error:', error);
                }
            }
        }, 100);

        return (
            <div>
                <label>{label}</label>
                <div style={{ 
                    width: '200px', 
                    height: '150px',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    overflow: 'hidden',
                    marginTop: '10px'
                }}>
                    <div 
                        id={canvasId}
                        style={{
                            width: '100%',
                            height: '100%'
                        }}
                    />
                </div>
            </div>
        );
    }

    // Sửa lại hàm renderFilePreview
    renderFilePreview(url, label) {
        if (!url) return null;
        let isSVGA = false;
        if (url.startsWith('blob:')) {
            const fieldName = this.getFieldNameByLabel(label);
            isSVGA = this.state.fileTypes && this.state.fileTypes[fieldName] === 'svga';
        } else {
            isSVGA = this.isSVGAFile(url);
        }
        
        if (isSVGA) {
            return this.renderSVGA(url, label);
        } else {
            return (
                <>
                    <label>{label}</label>
                    <img src={url} alt={label} style={{ maxWidth: '200px', maxHeight: '150px' }} />
                </>
            );
        }
    }

    // Thêm hàm để map label với field name
    getFieldNameByLabel(label) {
        const labelMap = {
            'Banner Nhỏ': 'miniBackgroundUrl',
            'Banner Lớn': 'largeBackgroundUrl', 
            'Nền Chính': 'mainBackgroundUrl'
        };
        return labelMap[label];
    }


    render() {
        const model = bindModel(this);
        const {
            loading,
            roomEvent,
            reviewAction,
            rejectReason,
        } = this.state;
        if (!roomEvent) {
            return (
                <div>
                    <div className="modal fade" id="modalUpdateRoomEvent" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalCenterTitle">Cập nhật Sự Kiện</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <p>Đang tải dữ liệu...</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        const isPendingReview = roomEvent.approvalStatus === 'PENDING';
        const isRejecting = reviewAction === 'REJECT';
        const hasRequiredBanners = Boolean(roomEvent.miniBackgroundUrl && roomEvent.largeBackgroundUrl);
        const modalTitle = isPendingReview
            ? 'Chi tiết và duyệt Sự Kiện'
            : roomEvent.id ? 'Cập nhật Sự Kiện' : 'Tạo Sự Kiện';

        return (
            <div>
                <div className="modal fade" id="modalUpdateRoomEvent" tabIndex={-1} role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalCenterTitle">{modalTitle}</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <ul className="nav nav-tabs" id="myTab" role="tablist">
                                    <li className="nav-item">
                                        <a className="nav-link active" id="setting-tab" data-toggle="tab" href="#setting" role="tab" aria-controls="setting" aria-selected="true">Cài đặt chính</a>
                                    </li>
                                </ul>

                                <div className="tab-content" id="myTabContent">
                                    {/* SETTING */}
                                    <div className="tab-pane fade show active" id="setting" role="tabpanel" aria-labelledby="setting-tab">
                                        <div>
                                            {isPendingReview && (
                                                <div className="alert alert-light border mt-3 mb-3">
                                                    <div><b>Người tạo:</b> {roomEvent.createdByUserName || '—'}{roomEvent.createdByUserId ? ` (${roomEvent.createdByUserId})` : ''}</div>
                                                    <div><b>Trạng thái:</b> <span className="badge badge-warning">Chờ duyệt</span></div>
                                                </div>
                                            )}
												<div id="liveRoomUID" className="row mb-2 mt-2">
												<div className="col-3">
													<label>ID Phòng <span style={{color: 'red'}}>*</span></label>
												</div>
												<div className="col-9">
													<input type="text" className="form-control" name="liveRoomUID" {...model('roomEvent.liveRoom.uid')} />
												</div>
											</div>
                                            <div id="language" className="row mb-2">
                                                <div className="col-3">
                                                    <label>Ngôn ngữ <span style={{color: 'red'}}>*</span></label>
                                                </div>
                                                <div className="form-check col-9">
                                                    <select
                                                        className="form-control"
                                                        type="text"
                                                        name="language"
                                                        {...model('roomEvent.language')} >
                                                        <option value="">Chọn</option>
                                                        <option value="vi">Vietnamese (IKARA)</option>
                                                        <option value="en.yokara">English (YOKARA)</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div id="liveRoomName" className="row mb-2">
                                                <div className="col-3">
                                                    <label>Tên phòng trên banner</label>
                                                </div>
                                                <div className="col-9">
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder="Ví dụ: Trà Honey"
                                                        {...model('roomEvent.liveRoom.name')}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row mb-3">
                                                <div className="col-3">
                                                    <label>Tạo banner bằng AI</label>
                                                </div>
                                                <div className="col-9">
                                                    <button
                                                        type="button"
                                                        className="btn btn-info mr-2"
                                                        disabled={this.state.aiGenerating
                                                            || this.state.verticalAiGenerationCount >= MAX_AI_GENERATIONS
                                                            || this.state.horizontalAiGenerationCount >= MAX_AI_GENERATIONS}
                                                        onClick={() => this.generateBannersWithAI('both')}
                                                    >
                                                        {this.state.aiGenerating ? (
                                                            <><span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Đang tạo...</>
                                                        ) : 'Tạo banner dọc và ngang'}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-info mr-2"
                                                        disabled={this.state.aiGenerating || this.state.verticalAiGenerationCount >= MAX_AI_GENERATIONS}
                                                        onClick={() => this.generateBannersWithAI('vertical')}
                                                    >
                                                        Chỉ tạo lại banner dọc
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-info"
                                                            disabled={this.state.aiGenerating
                                                            || this.state.horizontalAiGenerationCount >= MAX_AI_GENERATIONS
                                                            || !roomEvent.miniBackgroundUrl}
                                                        onClick={() => this.generateBannersWithAI('horizontal')}
                                                    >
                                                        Chỉ tạo lại banner ngang
                                                    </button>
                                                    <small className="form-text text-muted">
                                                        Ảnh dọc: {this.state.verticalAiGenerationCount}/{MAX_AI_GENERATIONS} lượt;
                                                        {' '}ảnh ngang: {this.state.horizontalAiGenerationCount}/{MAX_AI_GENERATIONS} lượt trong lần mở form này.
                                                    </small>
                                                    {isPendingReview && (
                                                        <div className={hasRequiredBanners ? 'alert alert-success mt-2 mb-0' : 'alert alert-warning mt-2 mb-0'}>
                                                            {hasRequiredBanners
                                                                ? 'Đã có đủ banner dọc và banner ngang. Có thể duyệt sự kiện.'
                                                                : 'Cần có đủ banner dọc và banner ngang trước khi duyệt.'}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div id="miniBackgroundUrl" className="row mb-2">
                                                <div className="col-3">
                                                    <label>Banner nhỏ sự kiện (dọc) <span style={{color: 'red'}}>*</span></label>
                                                </div>
                                                <div className="col-9">
                                                    <input
                                                        type="file"
                                                        className="custom-file-input"
                                                        name="miniBackgroundUrl"
                                                        onClick={(e) => {
                                                            console.log('File input clicked');
                                                            e.target.value = '';
                                                        }}
                                                        onInput={this.uploadAnimationToS3}
                                                    />
                                                    <label className="custom-file-label ml-3 mr-3" htmlFor="miniBackgroundUrl">Choose file</label>
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-3">
                                                    <label></label>
                                                </div>
                                                <div className="col-3">
                                                    {(roomEvent && roomEvent.miniBackgroundUrl) ? (
                                                        this.renderFilePreview(roomEvent.miniBackgroundUrl, "Banner Nhỏ")
                                                    ) : ""}
                                                </div>
                                            </div>
											<div id="largeBackgroundUrl" className="row mb-2">
												<div className="col-3">
                                                    <label>Banner lớn sự kiện (ngang) <span style={{color: 'red'}}>*</span></label>
												</div>
												<div className="col-9">
													<input
														type="file"
														className="custom-file-input"
														name="largeBackgroundUrl"
                                                        onClick={(e) => {
                                                            console.log('File input clicked');
                                                            // Reset value để có thể chọn lại cùng file
                                                            e.target.value = '';
                                                        }}
                                                        onInput={this.uploadAnimationToS3}
													/>
													<label className="custom-file-label ml-3 mr-3" htmlFor="largeBackgroundUrl">Choose file</label>
												</div>
											</div>
											<div className="row mb-2">
												<div className="col-3">
													<label></label>
												</div>
												<div className="col-3">
													{(roomEvent && roomEvent.largeBackgroundUrl) ? (
														this.renderFilePreview(roomEvent.largeBackgroundUrl, "Banner Lớn")
													) : ""}
												</div>
											</div>
                                            <div id="name" className="row mb-2">
                                                <div className="col-3">
                                                    <label>Tên Sự Kiện <span style={{color: 'red'}}>*</span></label>
                                                </div>
                                                <div className="col-9">
                                                    <input
                                                        className="form-control mb-2"
                                                        type="text"
                                                        name="name"
                                                        placeholder="Nhập Tên sự kiện..."
                                                        {...model('roomEvent.name')}
                                                    />
                                                </div>
                                            </div>
                                            <div id="description" className="row mb-2">
                                                <div className="col-3">
                                                    <label>Nội dung sự kiện</label>
                                                </div>
                                                <div className="col-9">
                                                    <textarea
                                                        className="form-control mb-2"
                                                        rows="4"
                                                        maxLength="1500"
                                                        placeholder="Hiển thị ở màn chi tiết sự kiện trên app"
                                                        {...model('roomEvent.description')}
                                                    />
                                                </div>
                                            </div>
                                            <div id="bannerDescription" className="row mb-2">
                                                <div className="col-3">
                                                    <label>Mô tả thêm trên banner</label>
                                                </div>
                                                <div className="col-9">
                                                    <textarea
                                                        className="form-control mb-2"
                                                        rows="4"
                                                        maxLength="500"
                                                        placeholder="Không bắt buộc — chỉ dùng khi tạo banner bằng AI"
                                                        {...model('bannerDescription')}
                                                    />
                                                </div>
                                            </div>
                                            <div id="name" className="row mb-2">
                                                <div className="col-3">
                                                    <label>Nền sự kiện</label>
                                                </div>
                                                <div className="col-9">
                                                    <input
                                                        type="file"
                                                        className="custom-file-input"
                                                        name="mainBackgroundUrl"
                                                        onClick={(e) => {
                                                            e.target.value = '';
                                                        }}
                                                        onInput={this.uploadAnimationToS3}
                                                    />
                                                    <label className="custom-file-label ml-3 mr-3" htmlFor="mainBackgroundUrl">Nền Chính</label>
                                                </div>
                                            </div>
                                            <div className="row mb-2">
                                                <div className="col-3"></div>
                                                <div className="col-9">
                                                    <div className="col-4" style={{
                                                        marginTop: '24px', padding: '0px'
                                                    }}>
                                                        {(roomEvent && roomEvent.mainBackgroundUrl) ? (
                                                            this.renderFilePreview(roomEvent.mainBackgroundUrl, "Nền Chính")
                                                        ) : ""}
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="timeStart" className="row mb-2">
                                                <div className="col-3">
                                                    <label>Deeplink</label>
                                                </div>
                                                <div className="col-9">
                                                    <input
                                                        className="form-control mb-2"
                                                        type="text"
                                                        name="deepLink"
                                                        {...model('roomEvent.deepLink')}
                                                    />
                                                </div>
                                            </div>
                                            <div id="timeStart" className="row mb-2">
                                                <div className="col-3">
                                                    <label>Thời gian bắt đầu <span style={{color: 'red'}}>*</span></label>
                                                </div>
                                                <div className="col-9">
                                                    <input
                                                        className="form-control mb-2"
                                                        type="datetime-local"
                                                        name="timeStart"
                                                        {...model('roomEvent.timeStart')}
                                                    />
                                                </div>
                                            </div>
                                                <div id="timeEnd" className="row mb-2">
                                                <div className="col-3">
                                                    <label>Thời gian kết thúc <span style={{color: 'red'}}>*</span></label>
                                                </div>
                                                <div className="col-9">
                                                    <input
                                                        className="form-control mb-2"
                                                        type="datetime-local"
                                                        name="timeEnd"
                                                        {...model('roomEvent.timeEnd')}
                                                    />
                                                </div>
                                            </div>
                                            <div id="timeShowStart" className="row mb-2">
                                                <div className="col-3">
                                                    <label>Hẹn giờ đăng <span style={{color: 'red'}}>*</span></label>
                                                </div>
                                                <div className="col-9">
                                                    <input
                                                        className="form-control mb-2"
                                                        type="datetime-local"
                                                        name="timeShowStart"
                                                        {...model('roomEvent.timeShowStart')}
                                                    />
                                                </div>
                                            </div>
                                                <div id="isHidden" className="row mb-2">
                                                    <div className="col-3">
                                                        <label>Ẩn sự kiện</label>
                                                    </div>
                                                    <div className="col-2">
                                                        <input 
                                                            type="checkbox" 
                                                            className="form-control" 
                                                            style={{
                                                                width: "15px",
                                                                outline: "none",
                                                                boxShadow: "none"
                                                            }}
                                                            name="isHidden" 
                                                            {...model('roomEvent.isHidden')} 
                                                        />
                                                    </div>
                                                </div>
                                                <div id="isSendNotification" className="row mb-2">
                                                    <div className="col-3">
                                                        <label>Gửi thông báo</label>
                                                    </div>
                                                    <div className="col-3">
                                                        <input
                                                            className="form-control mb-2"
                                                            type="checkbox" 
                                                            name="isSendNotification"
                                                            {...model('roomEvent.isSendNotification')}
                                                            style={{
                                                                width: "15px",
                                                                outline: "none",
                                                                boxShadow: "none"
                                                            }}
                                                            checked={roomEvent && roomEvent.isSendNotification}
                                                            onChange={this.handleChangeIsSendNotification}
                                                        />
                                                    </div>
                                                </div>
                                            <div id="timeSendNotification" className="row mb-2" hidden={!roomEvent || !roomEvent.isSendNotification}>
												<div className="col-3">
													<label>Thời gian gửi thông báo <span style={{color: 'red'}}>*</span></label>
												</div>
												<div className="col-9">
												<input
														className="form-control mb-2"
														type="datetime-local"
														name="timeSendNotification"
														{...model('roomEvent.timeSendNotification')}
													/>
												</div>
											</div>
                                            <div id="title" className="row mb-2" hidden={!roomEvent || !roomEvent.isSendNotification}>
												<div className="col-3">
													<label>Tiêu đề noti <span style={{color: 'red'}}>*</span></label>
												</div>
												<div className="col-9">
												<input
														className="form-control mb-2"
														type="text"
														name="title"
														{...model('roomEvent.title')}
													/>
												</div>
											</div>
											<div id="contentNotification" className="row mb-2" hidden={!roomEvent || !roomEvent.isSendNotification}>
												<div className="col-3">
													<label>Nội dung thông báo <span style={{color: 'red'}}>*</span></label>
												</div>
												<div className="col-9">
												<input
														className="form-control mb-2"
														type="text"
														name="content"
														{...model('roomEvent.content')}
													/>
												</div>
											</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Đóng</button>
                                {isPendingReview ? (
                                    isRejecting ? (
                                        <>
                                            <div className="w-100 text-left mb-2">
                                                <label>Lý do từ chối <span className="text-danger">*</span></label>
                                                <textarea
                                                    className="form-control"
                                                    rows="3"
                                                    maxLength="200"
                                                    value={rejectReason}
                                                    onChange={this.onChangeRejectReason}
                                                    placeholder="Nhập lý do để chủ phòng biết vì sao sự kiện không được duyệt"
                                                />
                                            </div>
                                            <button type="button" className="btn btn-outline-secondary" disabled={loading} onClick={this.cancelReject}>Quay lại</button>
                                            <button type="button" className="btn btn-danger" disabled={loading} onClick={() => this.reviewRoomEvent('REJECT')}>
                                                {loading ? 'Đang xử lý...' : 'Xác nhận từ chối'}
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <button type="button" className="btn btn-danger" disabled={loading || this.state.aiGenerating} onClick={this.startReject}>Từ chối</button>
                                            <button
                                                type="button"
                                                className="btn btn-success"
                                                disabled={loading || this.state.aiGenerating || !hasRequiredBanners}
                                                onClick={() => this.reviewRoomEvent('APPROVE')}
                                            >
                                                {loading ? 'Đang xử lý...' : 'Duyệt sự kiện'}
                                            </button>
                                        </>
                                    )
                                ) : loading ? (
                                    <button style={{ width: "120px" }} className="btn btn-red" type="button" disabled>
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Xác nhận...
                                    </button>
                                ) : (
                                    <button style={{ width: "120px" }} type="button" className="btn btn-red" onClick={this.saveRoomEvent}>Xác nhận</button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

ModalUpdateRoomEvent.contextType = MyContext;
